import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';

import { IonicSelectableModule } from 'ionic-selectable';

import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore'; //FirestoreSettingsToken

import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

import { AddActivityFormatComponent } from './activity/add-format/add-format.component';
import { AddChoirPerformanceComponent } from './choir/add-performance/add-performance.component';
import { AddChurchComponent } from './add-church/add-church.component';
import { AddITPerformanceComponent } from './it/add-performance/add-performance.component';
import { AddLeagueComponent } from './add-league/add-league.component';
import { AddMediaPerformanceComponent } from './media/add-performance/add-performance.component';
import { AddMemberComponent } from './add-member/add-member.component';
import { AddTeamComponent } from './add-team/add-team.component';
import { AddTheatrePerformanceComponent } from './theatre/add-performance/add-performance.component';
import { AddUserComponent } from './add-user/add-user.component';

import { EditActivityFormatComponent } from './activity/edit-format/edit-format.component';
import { EditChoirPerformanceComponent } from './choir/edit-performance/edit-performance.component';
import { EditChurchComponent } from './edit-church/edit-church.component';
import { EditITPerformanceComponent } from './it/edit-performance/edit-performance.component';
import { EditLeagueComponent } from './edit-league/edit-league.component';
import { EditMediaPerformanceComponent } from './media/edit-performance/edit-performance.component';
import { EditMemberComponent } from './edit-member/edit-member.component';
import { EditTeamComponent } from './edit-team/edit-team.component';
import { EditTheatrePerformanceComponent } from './theatre/edit-performance/edit-performance.component';
import { EditUserComponent } from './edit-user/edit-user.component';

import { ActivityFormatListComponent } from './activity/format-list/format-list.component';
import { ChurchListComponent } from './church-list/church-list.component';
import { ChoirPerformanceListComponent } from './choir/performance-list/performance-list.component';
import { ITPerformanceListComponent } from './it/performance-list/performance-list.component';
import { LeagueListComponent } from './league-list/league-list.component';
import { MediaPerformanceListComponent } from './media/performance-list/performance-list.component';
import { MemberListComponent } from './member-list/member-list.component';
import { TeamListComponent } from './team-list/team-list.component';
import { TheatrePerformanceListComponent } from './theatre/performance-list/performance-list.component';
import { UserListComponent } from './user-list/user-list.component';

import { ImportMembersComponent } from './import-members/import-members.component';
import { MigrateUsersComponent } from './migrate-users/migrate-users.component';

import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFileUploaderModule } from "angular-file-uploader";
import { environment } from '../environments/environment';
import { AngularFireFunctionsModule } from '@angular/fire/functions';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { RegistrationClosedComponent } from './registration-closed/registration-closed.component';
import { LoginComponent } from './login/login.component';
import { MenuComponent } from './menu/menu.component';
import { AppRoutingModule } from './app-routing.module';

import { 
  ActivityFormatService, AgeGroupService, ArrayService, AuthService, ChoirPerformanceService, ChurchService, 
  DatabaseService, EmailService, FileService, ITPerformanceService, TheatrePerformanceService, FestivalUserService, ResearchPerformanceService 
} from 'src/core/services';

import { OrderByPipe } from 'src/core/pipes/order-by.pipe';
import { ReportListComponent } from './reports/report-list/report-list.component';
import { ReportViewerComponent } from './reports/report-viewer/report-viewer.component';
import { SafePipe } from 'src/core/pipes/safe-url.pipe';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ResearchPerformanceListComponent } from './research/performance-list/performance-list.component';
import { EditResearchPerformanceComponent } from './research/edit-performance/edit-performance.component';
import { AddResearchPerformanceComponent } from './research/add-performance/add-performance.component';
import { MigrateActivityFormatsComponent } from './migrate-activity-formats/migrate-activity-formats.component';
import { MigrateSportLeaguesComponent } from './migrate-sport-leagues/migrate-sport-leagues.component';
import { TextService } from 'src/core/services/text-service';
import { VisualArtPerformanceListComponent } from './visualArt/performance-list/performance-list.component';
import { AddVisualArtPerformanceComponent } from './visualArt/add-performance/add-performance.component';
import { EditVisualArtPerformanceComponent } from './visualArt/edit-performance/edit-performance.component';
import { NoAccessComponent } from './no-access/no-access.component';

@NgModule({
  declarations: [
    AppComponent,
    
    AddActivityFormatComponent,
    EditActivityFormatComponent,
    ActivityFormatListComponent,

    AddChoirPerformanceComponent,
    EditChoirPerformanceComponent,
    ChoirPerformanceListComponent,

    AddITPerformanceComponent,
    EditITPerformanceComponent,
    ITPerformanceListComponent,

    AddChurchComponent,
    EditChurchComponent,
    ChurchListComponent,

    AddLeagueComponent,
    EditLeagueComponent,
    LeagueListComponent,
    
    AddMediaPerformanceComponent,
    EditMediaPerformanceComponent,
    MediaPerformanceListComponent,

    AddMemberComponent,
    EditMemberComponent,
    MemberListComponent,

    AddResearchPerformanceComponent,
    EditResearchPerformanceComponent,
    ResearchPerformanceListComponent,

    AddTeamComponent,
    EditTeamComponent,
    TeamListComponent,

    AddTheatrePerformanceComponent,
    EditTheatrePerformanceComponent,
    TheatrePerformanceListComponent,

    AddVisualArtPerformanceComponent,
    EditVisualArtPerformanceComponent,
    VisualArtPerformanceListComponent,

    AddUserComponent,
    EditUserComponent,
    UserListComponent,

    ImportMembersComponent,
    MigrateUsersComponent,
    MigrateActivityFormatsComponent,
    MigrateSportLeaguesComponent,
    
    ReportListComponent,
    ReportViewerComponent,
    
    DashboardComponent,
    LoginComponent,
    MenuComponent,
    NoAccessComponent,
    RegistrationClosedComponent,

    OrderByPipe,
    SafePipe
  ],
  entryComponents: [],
  imports: [
    AngularFireAuthModule,
    AngularFireFunctionsModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFileUploaderModule,
    FontAwesomeModule,
    BrowserModule,
    IonicModule.forRoot(),
    FormsModule,
    NgMultiSelectDropDownModule.forRoot(),
    IonicSelectableModule,
    AppRoutingModule,
    ReactiveFormsModule 
  ],
  providers: [
    ActivityFormatService,
    AgeGroupService,
    ArrayService,
    AuthService,
    ChoirPerformanceService,
    ITPerformanceService,
    ChurchService,
    DatabaseService,
    EmailService,
    FileService,
    ResearchPerformanceService,
    TheatrePerformanceService,
    FestivalUserService,
    StatusBar,
    SplashScreen,
    TextService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIconPacks(fas, fab, far);
  }
}
